import { createServiceStore } from 'common/store';
import { INITIAL_STATE } from './constants';
export var useFeedbackStore = createServiceStore({
    initialValues: INITIAL_STATE,
});
